import { useUser } from 'src/providers/UserProvider'

import { Heading1 } from 'src/components/atoms/Typography'

import { useGetAccountQuery } from 'src/config/generated/graphql'
import { GetAccountType } from 'src/types/account'

import { UpdateAccountDetailsForm } from '../forms/UpdateAccountDetailsForm'

export const UpdateAccountDetails = () => {
  const { user } = useUser()

  const { data } = useGetAccountQuery({
    variables: { id: user?.Account?.Id }
  })

  return (
    <>
      <Heading1>Account settings</Heading1>
      <UpdateAccountDetailsForm account={data?.account as GetAccountType} />
    </>
  )
}
